<template>
<!--    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"-->
<!--                      style="min-height: 300px"-->
<!--                      pulling-text="下拉重新获取数据"-->
<!--                      loosing-text="释放即可重新加载"-->
<!--                      loading-text=""-->
<!--                      success-text="数据获取成功">-->
<!--        <div>-->
<!--            <div class="top_tools_div">-->
<!--                <div style="background-color: white; box-shadow: 1px 1px 5px #999999;">-->
<!--                    <Wp_search_model :search-value="search_value"-->
<!--                                     font-color=""-->
<!--                                     :common-transparent="$common.transparent"-->
<!--                                     @clickToSearch="clickToSearch"-->
<!--                                     @searchInputClick="searchInputClick"-->
<!--                                     @getSearchValue="getSearchValue"-->
<!--                    ></Wp_search_model>-->

<!--                    <PddCategoryTabs ref="PddCategoryTabs" v-if="pdd_pid" @onSelect="selectCategory"></PddCategoryTabs>-->

<!--                    <div v-if="allParams.keyword || allParams.optid !== -2" style="padding: 2px 0px" id="checkbox_sort_div" :class="checkbox_sort_div">-->
<!--                        <van-divider-->
<!--                                :style="{borderColor: '#cccccc', 'margin-top': '0px', 'margin-bottom': '0px'}"></van-divider>-->

<!--                        &lt;!&ndash; 优惠券 &ndash;&gt;-->
<!--                        <van-checkbox-group v-model="check_result" @change="onCheckBoxChange">-->
<!--                            <van-row style="margin-left: 15px; margin-top: 10px; margin-bottom: 10px">-->
<!--                                <van-col span="12">-->
<!--                                    <van-checkbox :name="check_list[0]" shape="round" checked-color="#ff0000">-->
<!--                                        {{check_list[0]}}-->
<!--                                    </van-checkbox>-->
<!--                                </van-col>-->
<!--                                <van-col span="12">-->
<!--                                    <van-checkbox :name="check_list[1]" shape="round" checked-color="#ff0000">-->
<!--                                        {{check_list[1]}}-->
<!--                                    </van-checkbox>-->
<!--                                </van-col>-->
<!--                            </van-row>-->
<!--                        </van-checkbox-group>-->

<!--                        <van-divider-->
<!--                                :style="{borderColor: '#cccccc', 'margin-top': '0px', 'margin-bottom': '0px'}"></van-divider>-->
<!--                        &lt;!&ndash; 排序 &ndash;&gt;-->
<!--                        <PddSortTabs ref="jdSortTabs" @onSelect="onSortSelect"></PddSortTabs>-->

<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->


<!--            <div :style="{position: 'relative', top: allParams.keyword || allParams.optid !== optid_for_top ? '195px' : '110px'}">-->
<!--&lt;!&ndash;                <div style="text-align: center; margin-bottom: 10px">&ndash;&gt;-->
<!--&lt;!&ndash;                    <van-button type="danger" @click="getPinduoduoPid_pdd">测试——获取pid</van-button>&ndash;&gt;-->
<!--&lt;!&ndash;                    <van-button type="danger" @click="deletePinduoduoPid">测试——删除pid</van-button>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--                <div>-->
<!--                    <div style="margin-left: 15px; font-size: 12px; color: red">-->
<!--                        *预估佣金与实际佣金可能不同，请以订单中的佣金为准<br/>-->
<!--                    </div>-->

<!--                    <Divider dashed-->
<!--                             style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin-top: 10px; margin-bottom: 10px"></Divider>-->
<!--                </div>-->

<!--                <Wp_pull_list v-if="pdd_pid" ref="Wp_pull_list" :all-params="allParams"-->
<!--                         :top-params-pdd="topParams"-->
<!--                         :page-size="pageSize"-->
<!--                         :use-function="true"-->
<!--                         @getDatas="getDatas"-->
<!--                         @onLoad="onLoad"-->
<!--                >-->
<!--                    <PddSkuInfoCard-->
<!--                            v-for="(sku_info, index) in sku_list"-->
<!--                            v-bind:key="index"-->
<!--                            :skuInfo="sku_info"-->
<!--                    >-->
<!--                    </PddSkuInfoCard>-->
<!--                </Wp_pull_list>-->
<!--            </div>-->
<!--        </div>-->
<!--    </van-pull-refresh>-->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                      style="min-height: 300px"
                      pulling-text="下拉重新获取数据"
                      loosing-text="释放即可重新加载"
                      loading-text=""
                      success-text="数据获取成功">
        <div>
<!--            <div class="top_tools_div">-->
            <van-sticky>
                <div style="background-color: white;">
                    <Wp_search_model :search-value="search_value"
                                     font-color=""
                                     :common-transparent="$common.transparent"
                                     @clickToSearch="clickToSearch"
                                     @getSearchValue="getSearchValue"
                    ></Wp_search_model>

                </div>
            </van-sticky>

            <Wp_pdd_select_base ref="Wp_pdd_select_base"
                                :offset-top="52"
                                @onLoad="onLoad"
            ></Wp_pdd_select_base>
        </div>
    </van-pull-refresh>
</template>

<script>
    import Wp_search_model from "../../custom/Wp_search_model";
    import Wp_pdd_select_base from "./Wp_pdd_select_base";
    export default {
        name: "Wp_pdd_select",
        components: {Wp_pdd_select_base, Wp_search_model},
        data(){
            return{

                search_value: '',

                //下拉刷新结束
                isLoading: false,
            }
        },

        created() {
        },

        methods:{

            /**
             * 根据条件查询数据
             */
            clickToSearch() {
                this.$refs.Wp_pdd_select_base.clickToSearch();
                this.searchInputClick('0');
            },

            searchInputClick(id){
                this.$refs.Wp_pdd_select_base.searchInputClick(id);
            },

            getSearchValue(value){
                this.$refs.Wp_pdd_select_base.getSearchValue(value);
            },

            /**
             * 下拉刷新
             */
            onRefresh() {
                this.$refs.Wp_pdd_select_base.onRefresh();
            },

            onLoad(){
                //关闭下拉刷新
                this.isLoading = false;
            }
        }
    }
</script>

<style scoped>
    .top_tools_div{
        width: 100%;
        min-height: 80px;
        position: fixed;
        top: 0px;
        z-index: 1999;
        /*box-shadow: 0px 1px 5px #999*/
    }

    .checkbox_sort_div_hide {
        max-height: 0px;
        -webkit-transition: max-height 0.5s;
        transition: max-height 0.5s;
        overflow: hidden;
    }

    .checkbox_sort_div_show {
        overflow: hidden;
        -webkit-transition: max-height 0.5s;
        transition: max-height 0.5s;
        max-height: 100px;
    }
</style>